<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { TabsMenu } from '@/shared/ui';
  import { usePermission } from '@/entities/Permission';

  const router = useRouter();
  const route = useRoute();
  const { can } = usePermission();

  const canReadList = can('read', 'Training');
  const canReadMatrix = can('readMatrix', 'Training');

  const options = computed(() =>
    [
      { id: 'lista-treinamentos', text: 'Lista de Treinamentos', visible: canReadList.value },
      { id: 'matriz-treinamentos', text: 'Matriz de Treinamentos', visible: canReadMatrix.value },
      { id: 'conteudos', text: 'Conteúdos', visible: true },
    ]
      .filter((option) => option.visible)
      .map(({ id, text }) => ({ id, text }))
  );

  const selectedOption = computed(() => {
    return (
      options.value.find((option) => route.path.includes(option.id))?.id ??
      options.value[0]?.id ??
      'conteudos'
    );
  });

  const handleOptionSelect = (optionId: string) => {
    router.push(`/treinamentos/${optionId}`);
  };
</script>

<template>
  <div data-testid="training-page" class="pt-4 p-6">
    <h3 class="text-gray-07 text-xl/7.5 font-semibold text-left mb-6">Treinamentos</h3>
    <TabsMenu
      :options="options"
      :selected-option="selectedOption"
      class="mb-6"
      @option-selected="handleOptionSelect"
    />
    <router-view />
  </div>
</template>
